import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function RelatoriosFinanceiros() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Relatórios Financeiros - N&N Soluções Empresariais | Análise Financeira em Goiânia';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Relatórios financeiros claros e eficientes em Goiânia. Análises detalhadas para decisões assertivas e gestão financeira estratégica da sua empresa.');
    }

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Relatórios Financeiros",
      "description": "Relatórios claros e eficientes para decisões assertivas",
      "url": `${import.meta.env.VITE_SITE_URL || "https://example.com"}/servicos/relatorios-financeiros`,
      "provider": {
        "@type": "Organization",
        "name": "N&N Soluções Empresariais",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Av. Goiás, 606",
          "addressLocality": "Goiânia",
          "addressRegion": "GO",
          "postalCode": "74015-010",
          "addressCountry": "BR"
        }
      },
      "areaServed": "Goiânia",
      "serviceType": "Análise Financeira"
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(script => {
        if (script.text.includes('Relatórios Financeiros')) {
          script.remove();
        }
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header/Navigation */}
      <header className="bg-white shadow-sm fixed w-full top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/3e6f8fcc8f2630e876a6bece5f75fd5d/1e6fcf1846e59e804b7269319d1935e6.png" 
                alt="N&N Soluções Empresariais" 
                className="h-16 w-auto cursor-pointer"
                onClick={() => navigate('/')}
              />
            </div>
            <nav className="hidden md:flex space-x-8">
              <button onClick={() => navigate('/')} className="text-gray-700 transition-colors cursor-pointer" style={{ color: '#72142B' }}>Home</button>
              <button onClick={() => navigate('/servicos')} className="text-gray-700 transition-colors cursor-pointer" style={{ color: '#72142B' }}>Serviços</button>
              <button onClick={() => navigate('/sobre')} className="text-gray-700 transition-colors cursor-pointer" style={{ color: '#72142B' }}>Sobre</button>
              <button onClick={() => navigate('/contato')} className="text-gray-700 transition-colors cursor-pointer" style={{ color: '#72142B' }}>Contato</button>
              <button onClick={() => navigate('/agendamento')} className="text-gray-700 transition-colors cursor-pointer" style={{ color: '#72142B' }}>Agendamento</button>
            </nav>
            <a 
              href="https://wa.me/5562993911090"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white px-6 py-2 rounded-full hover:opacity-90 transition-all duration-300 whitespace-nowrap cursor-pointer"
              style={{ backgroundColor: '#72142B' }}
            >
              Fale Conosco
            </a>
          </div>
        </div>
      </header>

      {/* Breadcrumb */}
      <div className="bg-gray-50 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex" aria-label="Breadcrumb">
            <ol className="flex items-center space-x-4">
              <li>
                <button onClick={() => navigate('/')} className="text-gray-500 hover:text-gray-700 cursor-pointer">
                  Home
                </button>
              </li>
              <li>
                <i className="ri-arrow-right-s-line text-gray-400"></i>
              </li>
              <li>
                <button onClick={() => navigate('/servicos')} className="text-gray-500 hover:text-gray-700 cursor-pointer">
                  Serviços
                </button>
              </li>
              <li>
                <i className="ri-arrow-right-s-line text-gray-400"></i>
              </li>
              <li>
                <span className="font-medium" style={{ color: '#72142B' }}>Relatórios Financeiros</span>
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Hero Section */}
      <section 
        className="relative py-32 overflow-hidden"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20financial%20analyst%20working%20with%20detailed%20financial%20reports%20and%20charts%20on%20modern%20desk%2C%20computer%20displaying%20financial%20dashboard%20with%20graphs%20and%20analytics%2C%20organized%20workspace%20with%20financial%20documents%20and%20calculator%20conveying%20expertise%20in%20financial%20analysis&width=1920&height=800&seq=relatorios-financeiros-hero&orientation=landscape')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#72142B]/80 via-[#72142B]/40 to-transparent"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6">
              Relatórios Financeiros
            </h1>
            <p className="text-xl text-white/90 mb-8">
              Relatórios claros e eficientes para decisões assertivas. Transformamos dados financeiros em informações estratégicas para o crescimento do seu negócio.
            </p>
            <a 
              href="https://wa.me/5562993911090"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 hover:transform hover:scale-105 whitespace-nowrap cursor-pointer"
              style={{ backgroundColor: '#FAF7F2', color: '#72142B' }}
            >
              Solicitar Orçamento
            </a>
          </div>
        </div>
      </section>

      {/* Serviço Detalhado */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl font-bold mb-6" style={{ color: '#72142B' }}>
                Informações que Geram Resultados
              </h2>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Nossos relatórios financeiros vão além de números. Criamos análises personalizadas que revelam oportunidades, identificam riscos e orientam decisões estratégicas. Com informações claras e objetivas, você terá o controle total sobre a saúde financeira da sua empresa.
              </p>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center mr-4 mt-1" style={{ backgroundColor: '#72142B' }}>
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2" style={{ color: '#72142B' }}>Análise Detalhada</h3>
                    <p className="text-gray-600">Relatórios completos com análises profundas da situação financeira</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center mr-4 mt-1" style={{ backgroundColor: '#72142B' }}>
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2" style={{ color: '#72142B' }}>Linguagem Acessível</h3>
                    <p className="text-gray-600">Informações apresentadas de forma clara e compreensível</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center mr-4 mt-1" style={{ backgroundColor: '#72142B' }}>
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2" style={{ color: '#72142B' }}>Periodicidade Personalizada</h3>
                    <p className="text-gray-600">Relatórios mensais, trimestrais ou conforme sua necessidade</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20financial%20consultant%20presenting%20detailed%20financial%20reports%20with%20charts%20and%20graphs%20in%20modern%20office%2C%20computer%20screen%20showing%20financial%20dashboard%20and%20analytics%2C%20organized%20workspace%20conveying%20expertise%20in%20financial%20analysis%20and%20business%20intelligence&width=600&height=500&seq=relatorios-financeiros-detail&orientation=landscape"
                alt="Relatórios Financeiros Profissionais"
                className="w-full h-auto rounded-2xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Tipos de Relatórios */}
      <section className="py-20" style={{ backgroundColor: '#FAF7F2' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4" style={{ color: '#72142B' }}>
              Tipos de Relatórios
            </h2>
            <p className="text-xl text-gray-600">Informações estratégicas para cada necessidade</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-line-chart-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>DRE Gerencial</h3>
              <p className="text-gray-600">Demonstração de resultados com análise de rentabilidade e margem</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-money-dollar-circle-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>Fluxo de Caixa</h3>
              <p className="text-gray-600">Controle de entradas e saídas com projeções futuras</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-pie-chart-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>Análise de Custos</h3>
              <p className="text-gray-600">Detalhamento de custos fixos, variáveis e margem de contribuição</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-bar-chart-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>Indicadores de Performance</h3>
              <p className="text-gray-600">KPIs financeiros para acompanhar o desempenho do negócio</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-calendar-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>Relatórios Comparativos</h3>
              <p className="text-gray-600">Análise de evolução mensal, trimestral e anual</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-focus-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>Análise de Cenários</h3>
              <p className="text-gray-600">Projeções e simulações para planejamento estratégico</p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefícios */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4" style={{ color: '#72142B' }}>
              Benefícios dos Nossos Relatórios
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Transforme dados em decisões estratégicas com relatórios que realmente fazem a diferença no seu negócio
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-eye-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>Visão Clara</h3>
              <p className="text-gray-600">Entenda exatamente onde sua empresa está financeiramente</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-lightbulb-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>Decisões Assertivas</h3>
              <p className="text-gray-600">Tome decisões baseadas em dados concretos e análises precisas</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-time-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>Economia de Tempo</h3>
              <p className="text-gray-600">Informações organizadas e prontas para uso imediato</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-trophy-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>Crescimento</h3>
              <p className="text-gray-600">Identifique oportunidades de crescimento e otimização</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section 
        className="py-20"
        style={{
          background: `linear-gradient(135deg, #72142B 0%, #8B1538 50%, #72142B 100%)`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Transforme dados em estratégia
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto">
            Solicite seus relatórios financeiros personalizados e tenha o controle total sobre o futuro da sua empresa
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://wa.me/5562993911090"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-8 py-4 rounded-full hover:opacity-90 transition-all duration-300 whitespace-nowrap cursor-pointer text-lg font-semibold"
              style={{ backgroundColor: '#FAF7F2', color: '#72142B' }}
            >
              Solicitar Relatório
            </a>
            <button 
              onClick={() => navigate('/agendamento')}
              className="border-2 border-white text-white px-8 py-4 rounded-full hover:bg-white transition-all duration-300 whitespace-nowrap cursor-pointer text-lg font-semibold"
              style={{ borderColor: '#FAF7F2', color: '#FAF7F2' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#FAF7F2';
                e.currentTarget.style.color = '#72142B';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = '#FAF7F2';
              }}
            >
              Agendar Consulta
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="text-white py-16" style={{ backgroundColor: '#72142B' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="col-span-1 md:col-span-2">
              <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                N&N Soluções Empresariais
              </h3>
              <p className="text-white/80 mb-6">
                Simplificando sua contabilidade para você focar no que realmente importa.
              </p>
              <div className="space-y-2">
                <p className="flex items-center text-gray-300">
                  <i className="ri-phone-line mr-3"></i>
                  WhatsApp: (62) 99391-1090
                </p>
                <p className="flex items-center text-gray-300">
                  <i className="ri-mail-line mr-3"></i>
                  contato@nnsolucoes.com.br
                </p>
                <p className="flex items-center text-gray-300">
                  <i className="ri-map-pin-line mr-3"></i>
                  Av. Goiás, 606 - Setor Central, Goiânia - GO
                </p>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Links Úteis</h4>
              <ul className="space-y-2">
                <li><button onClick={() => navigate('/')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Home</button></li>
                <li><button onClick={() => navigate('/servicos')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Serviços</button></li>
                <li><button onClick={() => navigate('/sobre')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Sobre</button></li>
                <li><button onClick={() => navigate('/contato')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Contato</button></li>
                <li><button onClick={() => navigate('/agendamento')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Agendamento</button></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Nossos Serviços</h4>
              <ul className="space-y-2">
                <li><button onClick={() => navigate('/servicos/gestao-contabil')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Gestão Contábil</button></li>
                <li><button onClick={() => navigate('/servicos/gestao-fiscal')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Gestão Fiscal</button></li>
                <li><button onClick={() => navigate('/servicos/relatorios-financeiros')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Relatórios Financeiros</button></li>
                <li><span className="text-white/80">Gestão de Pessoas</span></li>
                <li><span className="text-white/80">Consultoria Empresarial</span></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-white/20 mt-12 pt-8 text-center">
            <p className="text-white/80">
              © 2024 N&N Soluções Empresariais. Todos os direitos reservados. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white ml-1 cursor-pointer" style={{ color: '#FAEBEA' }}>
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
